'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@mui/material";
import AlbumCard from "./AlbumCard";
import AlbumCardSkeleton from "./AlbumCardSkeletion";
export default function DpAlbumView(t0) {
  const $ = _c(5);
  const {
    albums,
    isLoading
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="grid grid-cols-2 gap-2 p-3 bg-white ">{Array.from({
          length: 2
        }).map(_temp)}</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (albums.length === 0) {
    return null;
  }
  let t1;
  if ($[1] !== albums) {
    t1 = albums.map(_temp2);
    $[1] = albums;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="grid grid-cols-2 gap-2 p-3 bg-white ">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp2(item) {
  return <AlbumCard key={item.id} album={item} />;
}
function _temp(_, idx) {
  return <AlbumCardSkeleton key={idx} />;
}